// Header.js
import React from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Box } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';

function Header({ toggleMode, mode }) {
  const location = useLocation();

  return (
    <AppBar position="static">
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          overflowX: 'hidden',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 1, overflow: 'hidden' }}>
          <Typography
            variant="h1"
            noWrap
            sx={{
              fontSize: {
                xs: '1.2rem',
                sm: '1.5rem',
                md: '2rem',
              },
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '60vw',
              flexShrink: 1,
            }}
          >
            How to Drink
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {location.pathname !== '/' && (
            <Button component={Link} to="/" color="inherit">
              Home
            </Button>
          )}
          {location.pathname === '/drinks' && (
            <Button component={Link} to="/episodes" color="inherit">
              Episodes
            </Button>
          )}
          {location.pathname === '/episodes' && (
            <Button component={Link} to="/drinks" color="inherit">
              Drinks
            </Button>
          )}
          <IconButton color="inherit" onClick={toggleMode} sx={{ ml: 1 }}>
            {mode === 'dark' ? <LightMode /> : <DarkMode />}
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
